import { connect } from 'react-redux';
import RoundsModal from '../components/rounds_modal';
import { fetchPreviewEvents } from '../actions/leaderboardV2_index';
import { selectIsManagerSite, selectRoundDates } from '../selectors';
import { roundLabelWithDate } from '../utils/round_label_utils';

const defaultFormatLabel = roundLabelWithDate;

const mapStateToProps = (state, ownProps) => ({
  roundId: ownProps.roundId || state.leaderboardV2.roundId,
  rounds: ownProps.rounds || state.leaderboardV2.roundList,
  eventsList: state.leaderboardV2.eventsList,
  roundDates: selectRoundDates(state),
  isManagerSite: selectIsManagerSite(state),
  formatLabel: ownProps.formatLabel ?? defaultFormatLabel,
});

const mapDispatchToProps = (dispatch) => ({
  fetchPreviewEvents: (roundId) => dispatch(fetchPreviewEvents(roundId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoundsModal);
